import _ from 'lodash';

import { DISCOUNT_POINTS_FEE, HARDCODED_FEES } from 'constants/feeTypes';
import { getAllowedCategoryIds } from 'utils/feeTypes';
import { caseInsensitiveIncludes } from 'utils/string';

export const getExtraFeeProps = ({
  feeTypeId,
  feeTypeName = '',
  isManageDiscountPointsAllowed,
}) => {
  const isDiscountPointsFee = caseInsensitiveIncludes(feeTypeName.toString(), DISCOUNT_POINTS_FEE);
  const isHardcodedFee = _.values(HARDCODED_FEES).some(
    fee => feeTypeName.toString().trim().toLowerCase() === fee.trim().toLowerCase(),
  );

  const isDiscountPointsReadonly = !isManageDiscountPointsAllowed && isDiscountPointsFee;

  const allowedCategoryIds = getAllowedCategoryIds(feeTypeId);

  const onFilterOptions = (options, params) => {
    const { inputValue } = params;

    return [
      ...options.filter(option => {
        const isSelectedProviderCategory = allowedCategoryIds.includes(
          option.feeProviderCategoryId,
        );

        return (
          isSelectedProviderCategory &&
          (!inputValue || caseInsensitiveIncludes(option.name, inputValue))
        );
      }),
    ];
  };

  return { isHardcodedFee, isDiscountPointsReadonly, onFilterOptions };
};
